import { HowToRegOutlined, PersonRemoveOutlined } from '@mui/icons-material';
import { FormControlLabel, Radio, Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { DELETE_GROUP_MEMBER_ACTION, OPTION_DESCRIPTION_MAX_WIDTH } from './constants';
import DeleteGroupOption from './DeleteGroupOption';

interface DeleteGroupAndUsersWithNoOtherGroupOptionProps {
  isSelected: boolean;
  membersLosingAccessCount: number;
  membersInOtherGroupsCount: number;
}

const DeleteGroupAndUsersWithNoOtherGroupOption: React.FC<DeleteGroupAndUsersWithNoOtherGroupOptionProps> = ({
  isSelected,
  membersLosingAccessCount,
  membersInOtherGroupsCount
}) => {
  const { translation } = useTranslation();

  return (
    <DeleteGroupOption isSelected={isSelected}>
      <FormControlLabel
        id="delete-orphaned-users-option"
        value={DELETE_GROUP_MEMBER_ACTION.unassign}
        control={<Radio />}
        label={translation.delete_group_and_users_without_other_groups}
      />
      <Stack flexDirection="row" sx={{ px: 1.25, gap: 2 }}>
        <Stack sx={{ maxWidth: OPTION_DESCRIPTION_MAX_WIDTH }}>
          <Stack flexDirection="row" gap={1}>
            <PersonRemoveOutlined color="error" />
            <Typography variant="body2" color="textPrimary">
              {`${membersLosingAccessCount} ${translation.users}`}
            </Typography>
          </Stack>
          <Typography variant="caption" color="textSecondary">
            {translation.will_be_permanently_deleted}
          </Typography>
        </Stack>
        <Stack sx={{ maxWidth: OPTION_DESCRIPTION_MAX_WIDTH }}>
          <Stack flexDirection="row" gap={1}>
            <HowToRegOutlined color="success" />
            <Typography variant="body2" color="textPrimary">
              {`${membersInOtherGroupsCount} ${translation.users}`}
            </Typography>
          </Stack>
          <Typography variant="caption" color="textSecondary">
            {translation.will_remain_in_other_groups}
          </Typography>
        </Stack>
      </Stack>
    </DeleteGroupOption>
  );
};

export default DeleteGroupAndUsersWithNoOtherGroupOption;
